<template>
  <div>
    <b-row>
      <b-col>
        <header-view
          :title="user.firstName + ' ' + user.lastName"
          :icon="'ti-user'">
        </header-view>
      </b-col>
    </b-row>
    <b-row class="mt-4">
      <b-col>
        <business-card
          class="rounded-0 h-100"
          :name="name"
          :contractNumber="user.contractNumber"
          :email="user.email"
          :roles="roles"
          :userTitle="user.title"
          :createdAt="user.createdAt"
          :dateOfBirth="user.dateOfBirth"
          :dateOfDeath="user.dateOfDeath"
          :showIcon="!!user.dateOfDeath"
          :imageSrc="user.avatarUuid">
        </business-card>
      </b-col>
      <b-col>
        <admin-user-status>
        </admin-user-status>
      </b-col>
    </b-row>

    <b-row class="mt-2"
           v-for="category in contractCategories"
           v-if="getContractsByCategory(category.value).length > 0"
           :key="category.value">
      <b-col>
        <AdminContractsCard
          :collapseId="category.value + 'Id'"
          :title="category.text"
          :items="getContractsByCategory(category.value)"
          :phView="false">
        </AdminContractsCard>
      </b-col>
    </b-row>

    <admin-user-address>
    </admin-user-address>

    <admin-user-contact-person>
    </admin-user-contact-person>

    <admin-user-invitation>
    </admin-user-invitation>

    <b-row class="mt-2">
      <b-col>
        <admin-user-documents>
        </admin-user-documents>
      </b-col>
    </b-row>

  </div>
</template>
<script>
  import AdminUserStatus from '@/components/admin/AdminUserStatus'
  import BusinessCard from '@/components/common/BusinessCard'
  import AdminUserAddress from '@/components/admin/AdminUserAddress'
  import AdminUserContactPerson from '@/components/admin/AdminUserContactPerson'
  import AdminUserInvitation from '@/components/admin/AdminUserInvitation'
  import AdminContractsCard from '@/components/admin/AdminContractsCard'
  import AdminUserDocuments from '@/components/admin/AdminUserDocuments'
  import HeaderView from '@/components/common/HeaderView'
  import utils from '@/utils'

  export default {
    name: 'AdminUserDetail',
    components: {
      AdminUserAddress,
      AdminUserContactPerson,
      AdminUserInvitation,
      AdminContractsCard,
      AdminUserDocuments,
      AdminUserStatus,
      BusinessCard,
      HeaderView
    },
    beforeRouteEnter (to, from, next) {
      next(vm => {
        const id = parseInt(to.params.id)
        vm.$store.dispatch('fetchUserById', id).then(() => {
          const user = vm.$store.getters.userById
          if (!user || user.id !== id) {
            next('/admin/users')
          }
        })
        vm.$store.dispatch('fetchAdminContracts', id)
        vm.$store.dispatch('fetchAdminContactPersons', id).catch(() => {
        })
      })
    },
    computed: {
      contractCategories () {
        return this.$store.getters.contractCategories.map(category => {
          return {
            value: category,
            text: this.$t('enums.contractCategories.' + category)
          }
        })
      },
      name () {
        return this.user.salutation
          ? this.$t('enums.salutations.' + this.user.salutation) + ' ' + this.user.firstName + ' ' + this.user.lastName : ''
      },
      roles () {
        if (this.user.roles) {
          return utils.getTranslatedRoles(this, this.user.roles).join(', ')
        }
      },
      user () {
        return this.$store.getters.userById
      }
    },
    methods: {
      getContractsByCategory (category) {
        return this.$store.getters.adminContracts.filter(contract => contract.contractCategory === category)
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/admin/AdminUserDetail.vue